import {KTCard} from '../../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {LoadingListLoading} from '../../../../utils/loading/loadingListLoading'
import {Header} from './components/header/Header'
import {SummaryTab} from './components/summary/SummaryTab'
import {ProductsTab} from './components/products/ProductsTab'
import {ClientsTab} from './components/clients/ClientsTab'
import {MetricProvider, useMetric} from './core/MetricProvider'

const groupBreadcrumbs: Array<PageLink> = [
  {
    title: 'Relatório de Métricas',
    path: '/reports/reportMetric/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportMetricContent = () => {
  const {activeTab, isLoading} = useMetric()

  return (
    <>
      <div className='card mb-2 mb-xl-2'>
        <div className='card-body py-0 position-relative'>
          <Header />
        </div>
      </div>
      <KTCard>
        {/* min-height reserva espaço para o loading na primeira busca, quando ainda não há dados. */}
        <div className='p-4 pt-0 pt-md-4 position-relative' style={{minHeight: '200px'}}>
          {activeTab === 'summary' && <SummaryTab />}
          {activeTab === 'products' && <ProductsTab />}
          {activeTab === 'clients' && <ClientsTab />}
          {isLoading && <LoadingListLoading title='Carregando' />}
        </div>
      </KTCard>
    </>
  )
}

const ReportMetricPage = () => (
  <>
    <PageTitle breadcrumbs={groupBreadcrumbs}>Relatório de Métricas</PageTitle>
    <MetricProvider>
      <ReportMetricContent />
    </MetricProvider>
  </>
)

export default ReportMetricPage
